// Feature-local HTTP wrapper. When USE_MOCK is true (the default in Phase 1)
// it dispatches to the in-process mock router. Flip the env var to "false"
// and this routes through the app-wide apiClient so no consumer code needs
// to change when Phase 2 ships the real server implementation.

import { apiClient } from "../../../api/client";
import { mockRequest, campaignStore } from "../mock";

export const USE_MOCK =
  import.meta.env.VITE_ADAPTIVE_SAMPLING_MOCK !== "false";

// Test/demo hatch: expose the mock store to window under a single namespace
// so Playwright (W6 x57.spec.ts) and manual demos can introspect campaign
// state without rigging react-query internals. No-op in production builds.
if (USE_MOCK && typeof window !== "undefined") {
  (window as unknown as {
    __ADAPTIVE_SAMPLING_DEBUG__?: {
      store: typeof campaignStore;
      getCampaign: (id: string) => ReturnType<typeof campaignStore.get>;
    };
  }).__ADAPTIVE_SAMPLING_DEBUG__ = {
    store: campaignStore,
    getCampaign: (id: string) => campaignStore.get(id),
  };
}

export type ApiCallOptions = {
  method?: string;
  body?: unknown;
  signal?: AbortSignal;
};

export async function apiCall<T = unknown>(
  path: string,
  options: ApiCallOptions = {},
): Promise<T> {
  const method = options.method ?? "GET";
  if (USE_MOCK) {
    return mockRequest<T>(path, method, options.body, options.signal);
  }
  return apiClient<T>(path, { method, body: options.body, signal: options.signal });
}
